import classNames from 'classnames'
import type {ReactNode, HTMLAttributes} from 'react'
import type {AlertBannerVariant} from 'interfaces'

export type AlertBannerProps = {
  variant: AlertBannerVariant
  children: ReactNode
} & HTMLAttributes<HTMLDivElement>

export const AlertBanner = ({
  variant,
  children,
  className,
  ...rest
}: AlertBannerProps): JSX.Element => {
  const baseClasses =
    'flex items-center justify-between gap-4 px-4 py-3 mt-3 w-full max-w-xl xl:max-w-2xl border'

  const variantClasses: Record<AlertBannerVariant, string> = {
    danger: 'border-red-500 bg-red-500 bg-opacity-10',
    warning: 'border-yellow-600 bg-yellow-600 bg-opacity-10',
    info: 'border-blue-500 bg-blue-500 bg-opacity-10',
    success: 'border-green-600 bg-green-600 bg-opacity-10',
  }

  const cls = classNames(baseClasses, variantClasses[variant], className)

  return (
    <div className={cls} role="alert" aria-live="polite" {...rest}>
      {children}
    </div>
  )
}
